/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetDriversQueryResponse, GetDriversQueryParams, GetDrivers400 } from '../entities/GetDrivers'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetDriversUrl() {
  return `/drivers` as const
}

/**
 * @description Get drivers
 * @summary Get drivers
 * {@link /drivers}
 */
export async function getDrivers(params: GetDriversQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetDriversQueryResponse, ResponseErrorConfig<GetDrivers400>, unknown>({
    method: 'GET',
    url: getGetDriversUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}